import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-item-list-brand',
  templateUrl: './item-list-brand.component.html',
  styleUrls: ['./item-list-brand.component.sass']
})
export class ItemListBrandComponent implements OnInit {

  @Input() item: any = [];
  @Output() brandSelected: EventEmitter<any> = new EventEmitter<any>();

  public hasAutorization: boolean = false;

  constructor() { }

  ngOnInit(): void {
    if(this.item?.richieste && this.item?.richieste.length > 0){
      this.hasAutorization = this.item?.richieste[0]?.stato == "AUTORIZZATO";
    } else if(this.item?.clienti_brand_retailer && this.item?.clienti_brand_retailer.length > 0){
      this.hasAutorization = this.item?.clienti_brand_retailer[0]?.stato == "AUTORIZZATO";
    }
  }

  selectBrand(item: any) {
    this.brandSelected.emit(item);
  }

}
